<script lang="ts" setup>
  import { route } from '../../../shared/config/routes.ts';
  import IndexView from './IndexView.vue';
</script>

<template>
  <IndexView
    @join-game="$router.push({ name: route.gameCodeRegister })"
    @host-game="$router.push({ name: route.spotifySignIn })"
  />
</template>
